import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-menu-order",
  "use": "icon-menu-order-usage",
  "viewBox": "0 0 48 48",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 48 48\" id=\"icon-menu-order\"><defs><mask id=\"icon-menu-order_ipSTransactionOrder0\"><g fill=\"none\" stroke-linejoin=\"round\" stroke-width=\"4\" data-swindex=\"0\"><rect width=\"30\" height=\"36\" x=\"9\" y=\"8\" fill=\"#fff\" stroke=\"#fff\" rx=\"2\" /><path stroke=\"#fff\" stroke-linecap=\"round\" d=\"M18 4v6m12-6v6\" /><path stroke=\"#000\" stroke-linecap=\"round\" d=\"M16 19h16m-16 8h12m-12 8h8\" /></g></mask></defs><path fill=\"currentColor\" d=\"M0 0h48v48H0z\" mask=\"url(#icon-menu-order_ipSTransactionOrder0)\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/menu/order.svg
// module id = 52vv
// module chunks = 63